// 全项目唯一占位图定义。前端 AppImage 与后端 database.js seed 共用，禁止在他处重复定义。
// 山峰 path 已修正：折线限制在图片框 x80-220 / y80-200 内（原图 x25-275 戳出框外）。
const PLACEHOLDER_SVG =
  '<svg width="300" height="300" xmlns="http://www.w3.org/2000/svg">' +
  '<rect width="300" height="300" fill="#f0f0f0"/>' +
  '<g fill="#ccc">' +
  // 图片框（不变）：x80-220 / y80-200
  '<path d="M220 180c0 11-9 20-20 20H100c-11 0-20-9-20-20V100c0-11 9-20 20-20h100c11 0 20 9 20 20z" opacity="0.3"/>' +
  // 山峰（修正）：折线点 (85,195)(115,150)(145,180)(165,140)(185,180)(210,145)(210,195)，全在框内
  '<path d="M85 195 L115 150 L145 180 L165 140 L185 180 L210 145 L210 195 Z" opacity="0.5"/>' +
  // 太阳（不变）：(165,125) r10
  '<circle cx="165" cy="125" r="10" opacity="0.5"/>' +
  '</g></svg>'

module.exports = {
  PLACEHOLDER_SVG,
  PLACEHOLDER_DATA_URI: 'data:image/svg+xml,' + encodeURIComponent(PLACEHOLDER_SVG)
}
